var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 35") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-9.4891385%",
    y1: "79.3105672%",
    x2: "64.1066299%",
    y2: "25.9514967%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C47C6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-6.6555494%",
    y1: "79.3105672%",
    x2: "63.4347023%",
    y2: "25.9514967%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C47C6",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Light",
    transform: "translate(-1621.000000, -191.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1060.231746, 166.662443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.768254, 0.197842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(555.411362, 20.444044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6625281,25 C17.357911,25 18.9154163,24.6683168 20.3350441,24.0049505 C21.7546719,23.3415842 22.9342906,22.4158416 23.8739004,21.2277228 C24.5510201,20.1403076 24.5305938,19.3497194 23.8126215,18.8559581 C23.0946492,18.3621968 22.2775972,18.5092207 21.3614656,19.2970297 C19.9316247,21.0792079 18.0319788,21.970297 15.6625281,21.970297 C13.5790456,21.970297 11.8223839,21.2475248 10.392543,19.8019802 C8.96270203,18.3564356 8.24778156,16.5940594 8.24778156,14.5148515 C8.24778156,12.4356436 8.96270203,10.6683168 10.392543,9.21287129 C11.8223839,7.75742574 13.5790456,7.02970297 15.6625281,7.02970297 C17.8685684,7.02970297 19.747788,7.88118812 21.3001867,9.58415842 C22.058649,10.3909947 22.8318949,10.5041677 23.6199244,9.92367726 C24.4079538,9.34318684 24.4721862,8.59635052 23.8126215,7.68316832 C22.8525854,6.53465347 21.6678601,5.63366337 20.2584454,4.98019802 C18.8490308,4.32673267 17.3170584,4 15.6625281,4 C12.6802885,4 10.1576405,5.02475248 8.09458432,7.07425743 C6.03152811,9.12376238 5,11.6039604 5,14.5148515 C5,17.4257426 6.03152811,19.9009901 8.09458432,21.9405941 C10.1576405,23.980198 12.6802885,25 15.6625281,25 Z",
    id: "C-Copy-13",
    fill: "url(#linearGradient-1)",
    transform: "translate(14.683435, 14.500000) rotate(-315.000000) translate(-14.683435, -14.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3622758,19.945671 C16.1501391,19.945671 16.8739292,19.7877266 17.5336461,19.4718379 C18.1933629,19.1559492 18.7415449,18.7151194 19.1781921,18.1493485 C19.4928572,17.6315318 19.4833648,17.2550612 19.1497151,17.0199368 C18.8160653,16.7848124 18.4363722,16.8548237 18.0106356,17.2299709 C17.3461726,18.0786271 16.463386,18.5029553 15.3622758,18.5029553 C14.3940583,18.5029553 13.577718,18.158778 12.913255,17.4704235 C12.2487919,16.7820689 11.9165604,15.9428421 11.9165604,14.9527431 C11.9165604,13.9626441 12.2487919,13.12106 12.913255,12.4279907 C13.577718,11.7349214 14.3940583,11.3883867 15.3622758,11.3883867 C16.3874474,11.3883867 17.2607416,11.7938558 17.9821586,12.6047941 C18.3346245,12.9890018 18.6939605,13.0428937 19.0601666,12.7664697 C19.4263727,12.4900457 19.4562222,12.1344093 19.1497151,11.6995607 C18.7035756,11.1526488 18.1530206,10.7236059 17.4980499,10.412432 C16.8430792,10.101258 16.1311545,9.945671 15.3622758,9.945671 C13.9763958,9.945671 12.8040932,10.4336484 11.845368,11.4096031 C10.8866427,12.3855578 10.4072801,13.5666045 10.4072801,14.9527431 C10.4072801,16.3388817 10.8866427,17.517571 11.845368,18.488811 C12.8040932,19.460051 13.9763958,19.945671 15.3622758,19.945671 Z",
    id: "C-Copy-14",
    stroke: "url(#linearGradient-2)",
    fill: "url(#linearGradient-2)",
    transform: "translate(14.907280, 14.945671) rotate(-315.000000) translate(-14.907280, -14.945671) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/companyIcon.e519c5592c778eccb392ae11ac58886b.svg";
export { ForwardRef as ReactComponent };